import { Button, LoadIndicator } from 'devextreme-react';
import { formatMessage } from 'devextreme/localization';
import React, { useEffect, Fragment } from 'react';
import PopupMVP from '../PopupMVP';

const ConfirmSkPopup = ({
  visible,
  onHiding,
  qcIds,
  dates,
  onConfirm,
  loading = false,
  okRequest = false
}) => {
  useEffect(() => {
    if (okRequest) {
      onHiding();
    }
  }, [okRequest, onHiding]);

  return (
    <PopupMVP title={'Подтверждение'} visible={visible} onHiding={onHiding}>
      <div className="formData">
        <h4>
          {' '}
          {formatMessage('textModal').textConfirmQC}
          {': '}
          {qcIds
            && qcIds.map((qcId, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Fragment key={i}>
                {qcId}
                {' '}
                {formatMessage('textModal').textFrom}
                {' '}
                {dates[i]}
                {i === qcIds.length - 1 ? '' : ','}
                {' '}
              </Fragment>
            ))}
          ?
        </h4>
        <div className="formButton">
          <Button
            type="default"
            stylingMode="contained"
            width={260}
            onClick={onConfirm}
          >
            <LoadIndicator className="indicator" visible={loading} />
            <span>{formatMessage('textButton').confirm}</span>
          </Button>
          <Button
            text={formatMessage('textButton').cancel}
            type="default"
            stylingMode="text"
            onClick={onHiding}
          />
        </div>
      </div>
    </PopupMVP>
  );
};

export default React.memo(ConfirmSkPopup);
